// extracted by mini-css-extract-plugin
export default {"tile":"yourofferstru-b3","tile--super-offer":"yourofferss3vrfy","tile__anchor":"youroffersO8XkQE","tile__actions":"yourofferssNpqLg"};